import React, { Component } from "react";
import PropTypes from "prop-types";
import FileButton from "./components/FileButton";
import { Button, Dropdown, Table } from "semantic-ui-react";
import Papa from "papaparse";
import api from "../../api";


class PriceUpdateForm extends Component {

    constructor(props) {
        super(props);
        this.state = {
            rows: null,
            supplier_id: null
        };
    }

    render() {

        return <div>

            {
                <div>

                    <Dropdown placeholder='Select Supplier'
                              value={this.state.supplier_id}
                              search
                              onChange={(e, { value }) => {
                                  this.setState({
                                      supplier_id: value
                                  });
                              }}
                              fluid selection options={this.props.suppliers.map((a) => {
                        return {
                            key: a.id,
                            text: a.name + " (" + a.supplier_id + ") ",
                            value: a.id
                        };
                    })}/>
                </div>}


            {this.state.supplier_id &&
            <div>
                <FileButton labal={"Select File"} fluid primary onSelect={(file) => {

                    Papa.parse(file, {
                        header: true,
                        dynamicTyping: true,
                        complete: (results) => {
                            console.log(results.data.filter((a) => {
                                return a.id !== null;
                            }));
                            this.setState({
                                rows: results.data.filter((a) => {
                                    return a.id !== null;
                                })
                                    .map((a) => {
                                        return {
                                            id: a.id,
                                            code: a.code,
                                            minQuantity: a.minQuantity ? a.minQuantity : 1,
                                            packageQuantity: a.packageQuantity ? a.packageQuantity : 1,
                                            price: a.price
                                        };
                                    })
                            });
                        }
                    });

                }}>Select Csv-File</FileButton>


                {this.state.rows &&

                <div>

                    <Table celled>
                        <Table.Header>
                            <Table.Row>
                                <Table.HeaderCell>ID</Table.HeaderCell>
                                <Table.HeaderCell>Code</Table.HeaderCell>
                                <Table.HeaderCell>Min Quantity</Table.HeaderCell>
                                <Table.HeaderCell>Package Quantity</Table.HeaderCell>
                                <Table.HeaderCell>Price</Table.HeaderCell>
                            </Table.Row>
                        </Table.Header>

                        <Table.Body>


                            {this.state.rows.map((row, key) => {
                                return <Table.Row key={key}>
                                    <Table.Cell>{row.id}</Table.Cell>
                                    <Table.Cell>{row.code}</Table.Cell>
                                    <Table.Cell>{row.minQuantity}</Table.Cell>
                                    <Table.Cell>{row.packageQuantity}</Table.Cell>
                                    <Table.Cell>{row.price}</Table.Cell>
                                </Table.Row>;
                            })
                            }


                        </Table.Body>
                    </Table>

                    <Button positive onClick={() => {
                        api.setSupplierPrices(this.state.supplier_id, this.state.rows)
                            .then(() => {
                                this.setState({
                                    rows: null,
                                    supplier_id: null
                                });
                            });

                    }}>Confirm</Button>

                </div>

                }

            </div>

            }


        </div>;

    }

    groupBy(xs, key) {
        return xs.reduce(function (rv, x) {
            (rv[x[key]] = rv[x[key]] || []).push(x);
            return rv;
        }, {});
    };

    getSupplierById(id) {
        return this.props.suppliers.reduce((a, b) => {
            if (Number.parseInt(b.id, 10) === Number.parseInt(id, 10)) {
                return b;
            }
            return a;
        }, {});
    }

}


PriceUpdateForm.propTypes = {
    suppliers: PropTypes.array.isRequired
};


export default PriceUpdateForm;



// WEBPACK FOOTER //
// ./src/scenes/Tools/scenes/Procurement/components/PriceUpdateForm/index.js